import { Grid } from "@mui/material";
import React from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import OrganizationGuestComponent from "../Components/OrganizationGuestComponent";
import MobileNavbar from "../Components/MobileNavbar";


function GuestLogin() {
  return (
    <Grid container>
      {/* <Navbar /> */}
      <MobileNavbar text={"VISITOR FORM"}/>
        <OrganizationGuestComponent />
      <Footer />
    </Grid>
  );
}

export default GuestLogin;
